import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[ripple]'
})
export class RippleDirective {

  constructor(private el: ElementRef, private renderer: Renderer2) {
  }

  @HostListener('click', ['$event'])
  createRipple(event: MouseEvent) {
    let originalPosition = this.el.nativeElement.style.position || getComputedStyle(this.el.nativeElement).position;
    let originalOverflow = this.el.nativeElement.style.overflow || getComputedStyle(this.el.nativeElement).overflow;
    this.renderer.setStyle(this.el.nativeElement, 'position', 'relative');
    this.renderer.setStyle(this.el.nativeElement, 'overflow', 'hidden');
    const button = this.el.nativeElement;
    const ripple = this.renderer.createElement('div');
    this.renderer.addClass(ripple, 'ripple');

    const rect = button.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height);
    const top = event.clientY - rect.top - size / 2;
    const left = event.clientX - rect.left - size / 2;

    this.renderer.setStyle(ripple, 'width', `${size}px`);
    this.renderer.setStyle(ripple, 'height', `${size}px`);
    this.renderer.setStyle(ripple, 'top', `${top}px`);
    this.renderer.setStyle(ripple, 'left', `${left}px`);

    this.renderer.appendChild(button, ripple);

    setTimeout(() => {
      this.renderer.removeChild(button, ripple);
      this.renderer.setStyle(this.el.nativeElement, 'position', originalPosition);
      this.renderer.setStyle(this.el.nativeElement, 'overflow', originalOverflow);
    }, 500);
  }
}
